(()=>{
  function initFlagReset(){
    const root=document.querySelector('[data-hfd]');
    if(!root||root.dataset.resetReady)return;
    root.dataset.resetReady='1';

    const sideButtons=[...root.querySelectorAll('[data-side]')];
    sideButtons.forEach(button=>{
      if(button.closest('.hfd__side-wrap'))return;
      const wrap=document.createElement('div');
      wrap.className='hfd__side-wrap';
      button.parentNode.insertBefore(wrap,button);
      wrap.appendChild(button);
      const reset=document.createElement('button');
      reset.type='button';
      reset.className='hfd__side-reset';
      reset.dataset.resetSide=button.dataset.side;
      reset.textContent='Reset';
      reset.setAttribute('aria-label',`Reset ${button.dataset.side} design to default`);
      wrap.appendChild(reset);
    });

    const visitorCountry=(root.dataset.visitorCountry||'us').toLowerCase();
    const defaults={
      front:{count:1,values:[visitorCountry]},
      back:{count:1,values:[visitorCountry]}
    };

    function setSelect(select,value){
      if(!select)return;
      select.value=value;
      if(!select.value)select.value='us';
      select.dispatchEvent(new Event('change',{bubbles:true}));
    }

    function resetSide(side){
      const d=defaults[side];
      if(!d)return;

      root.querySelector(`[data-side="${side}"]`)?.click();
      window.hfdUi?.nodes(root,side,'[data-count]').find(button=>button.dataset.count===String(d.count))?.click();

      const typeSelects=window.hfdUi?.nodes(root,side,'[data-selection-type]')||[...root.querySelectorAll('[data-selection-type]')];
      const flagSelects=window.hfdUi?.nodes(root,side,'[data-flag-selection]')||[...root.querySelectorAll('[data-flag-selection]')];
      d.values.forEach((value,index)=>{
        setSelect(typeSelects[index],'country');
        setSelect(flagSelects[index],value);
      });

      const lineSize=window.hfdUi?.pane(root,side)?.lineSize||root.querySelector('[data-line-size]');
      if(lineSize){lineSize.value='16';lineSize.dispatchEvent(new Event('change',{bubbles:true}));}
      const lineColor=window.hfdUi?.pane(root,side)?.lineColor||root.querySelector('[data-line-color]');
      if(lineColor){lineColor.value='#087df5';lineColor.dispatchEvent(new Event('input',{bubbles:true}));}
    }

    root.addEventListener('click',e=>{
      const reset=e.target.closest('[data-reset-side]');
      if(!reset)return;
      e.preventDefault();
      resetSide(reset.dataset.resetSide);
    });
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initFlagReset);else initFlagReset();
})();